module.exports = __webpack_public_path__ + "static/media/dashboard icon (active).05d697d9.svg";